import { safeGet } from '../../../../utils/objectUtils';
import { IAttribute, ILineItem } from '../cartInterface';
import { ContactLensAttributes } from './constants';
import { IContactLensAttributes } from './IContactLens';

export const reshapeAttributesData = (item: ILineItem) => {
  const childItem: IContactLensAttributes = { lineItems: []};
  const attributes = safeGet(item, 'variant.attributes', []);
  if (attributes.length) {
    Object.values(ContactLensAttributes).forEach(attribute => {
      const dimension = attributes.find((attr: IAttribute) => attr?.name === attribute);
      switch (dimension?.name) {
        case ContactLensAttributes.DIMENSION_SPHERE:
          childItem.lineItems.push({ type: 'SPH', value: dimension.value});
          break;
        case ContactLensAttributes.DIMENSION_CYLINDER:
          childItem.lineItems.push({ type: 'CYL', value: dimension.value});
          break;
        case ContactLensAttributes.DIMENSION_AXIS:
          childItem.lineItems.push({ type: 'AXIS', value: dimension.value});
          break;
        case ContactLensAttributes.DIMENSION_BASE:
          childItem.lineItems.push({ type: 'BC', value: dimension.value});
          break;
        case ContactLensAttributes.DIMENSION_DIAMETER:
          childItem.lineItems.push({ type: 'DIA', value: dimension.value});
          break;
        case ContactLensAttributes.DIMENSION_ADD:
          childItem.lineItems.push({ type: 'ADD', value: dimension.value});
          break;  
      }
    });
  }
  return childItem;
};
